import { Navbar, Container } from 'solid-bootstrap';

export function LoggedOutNavbar(props) {
    return <Navbar bg="primary" variant="dark">
        <Container>
            <Navbar.Brand href="/"><img src="/assets/img/hands.png" class="brand-mascot" /> Timechief</Navbar.Brand>
        </Container>
    </Navbar>
}